export default "__VITE_ASSET__BzwXQ1sF__"